import React from 'react';
import PropTypes from 'prop-types';
import { Add, InfoOutlined } from '@mui/icons-material';
import RowContextMenu from '../../components/DataGrid/RowContextMenu';
import DataGrid from '../../components/DataGrid/DataGrid';
import Status from '../../components/DataGrid/Status';
import CardPoints from './CardPoints';
import DetailDialog from '../../components/DetailDialog/DetailDialog';
import { Box } from '@mui/material';
import CardEditor from './CardEditor';

const Cards = ({ id }) => {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [openEditor, setOpenEditor] = React.useState(false);
    const [current, setCurrent] = React.useState(null);
    const [dlgTitle, setDlgTitle] = React.useState('Card Points');

    const columns = [
        { field: "name", headerName: "Name", align: "left", filterable: true, permanent: true,
            render : (row) => row?.Client?.name 
         },
        { field: "phone", headerName: "Phone", align: "left", filterable: true, permanent: true,
            render : (row) => row?.Client?.phone 
         },
        { field: "fidelity_code", headerName: "Code", align: "left", filterable: true },
        { field: "points", headerName: "Points", align: "left", filterable: true },
        { field: "status", headerName: "Status", align: "center", filterable: true,
            render : (row) => <Status value={row.status} />
         },
    ];

    // Define actions outside the RowContextMenu
    const rowActions = [
        { name: "Info", icon: <InfoOutlined fontSize="small" />, onClick: (row) => {
            setCurrent(row);
            setDlgTitle("Points for card: "+row.fidelity_code);
            setOpenDialog(true);
        } },
    ];

    const headerActions = [
            { name: "Add", icon: <Add fontSize="small" color='secondary' />, onClick: () => setOpenEditor(true) },
        ];

    const CustomRowContextMenu = (props) => {
        return <RowContextMenu {...props} actions={rowActions} />
    }

    return (
        <div>
            <DataGrid 
                columns={columns} 
                endPoint={`/api/v2/partner/${id}/cards`}  
                RowContextMenu={CustomRowContextMenu} 
                headerActions={headerActions}
                exportFileName='Cards' 
            />
            <DetailDialog 
                open={openDialog} 
                onClose={()=>setOpenDialog(false)} 
                title={dlgTitle}
                fullScreen={true}>
                    <Box sx={{p:2}}>
                        <CardPoints card={current} partnerId={id} />
                    </Box>
            </DetailDialog>
            <DetailDialog 
                open={openEditor} 
                onClose={()=>setOpenEditor(false)} 
                title={"New Card"}
                fullScreen={false}>
                    <Box sx={{p:2}}>
                        <CardEditor idPartner={id} onSave={()=>setOpenEditor(false)} onCancel={()=>setOpenEditor(false)} />
                    </Box>
            </DetailDialog>
        </div>
    );
};

Cards.propTypes = {
    id: PropTypes.string.isRequired,
};

export default Cards;